import { html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { BaseElement } from "../BaseElement";
import { LightTheme } from "../ThemeLight";

import { styles } from "./MediaThumbnailGrid.style";
import { IMedia } from "../../../main";
import { watch } from "../internal/watch";
import { getMediaTypeFromMimeType, MediaType } from "../../Media";

@customElement("ds-media-thumbnail-grid")
export class MediaThumbnailGrid extends BaseElement {
    static override styles = [styles, LightTheme];

    @property({ type: Array }) media?: IMedia[];
    @property({ type: Number }) maxImages = 16;

    @state() protected _filteredMedia?: IMedia[];

    @watch("media")
    mediaChanged() {
        this._filteredMedia = this.media?.filter((x) =>
            [MediaType.Image].includes(getMediaTypeFromMimeType(x.mimeType))
        );
    }

    override render() {
        return html` <div class="flex-row container">
            ${this._filteredMedia?.slice(0, this.maxImages).map(
                (x) =>
                    html`<ds-media
                        size="thumbnail_256px"
                        .media=${x}
                        noHeader
                        @click=${() =>
                            this._raiseEvent("ds-media-click", {
                                media: x,
                            })}
                    ></ds-media>`
            )}
        </div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-media-thumbnail-grid": MediaThumbnailGrid;
    }
}
